module.exports = require("vtk.js/Sources/Common/DataModel/PiecewiseFunction");